import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useSwr from "swr";
import { t } from "i18next";
import ReactPaginate from "react-paginate";
import { AiOutlineSearch } from "react-icons/ai";
import Colors from "../../../constant/Colors";
import axios from "axios";
import { BiSortAlt2 } from "react-icons/bi";
import Lottie from "react-lottie";
import animationData from "./animation_llnmaab2.json";
import animationLoading from "./animation-loading.json";
import { IoCloseOutline } from "react-icons/io5";

export const fetcher = (url) => axios.get(url).then((res) => res.data);

function ShowPaginationData({
  columns,
  onClickItem,
  label,
  url,
  returnAllData,
  rightButton,
  defaultSort = [],
  hrefId = "_id",
}) {
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const history = useHistory();
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState(defaultSort);
  const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;

  const { data, isLoading, error } = useSwr(
    url(
      `page=${page}&search=${search}&sort=${JSON.stringify(
        sort
      )}&filter=${JSON.stringify(filter)}&centerId=${currentCenterId}`
    ),
    fetcher
  );

  const language = useTranslation().i18n.language;
  const [unSelectedColumns, setUnSelectedColumns] = useState([]);

  useEffect(() => {
    if (data) {
      setPageCount(data.pagination?.pageCount);
    }
  }, [data]);

  if (error) return <Error />;
  // if (isLoading) return <Loading />;

  const handleNext = (a) => {
    const newVal = a.selected + 1;
    if (newVal > page) {
      setPage((p) => {
        return p + 1;
      });
    } else if (newVal < page) {
      setPage((p) => {
        return p - 1;
      });
    }
  };
  // console.log(data);
  return (
    <div
      style={{ direction: language === "en" ? "ltr" : "rtl" }}
      className='flex items-center justify-center flex-1 w-full overflow-x-hidden '>
      <div className='flex flex-col w-[90%] h-[90%] '>
        <div className='pb-3 border-b'>
          <div className='flex items-center justify-between'>
            <div className='text-3xl '>{t(label)}</div>
            {rightButton}
          </div>
        </div>
        <div>
          {/* Table Header */}
          <div className='flex justify-between max-md:flex-col'>
            <div className='flex items-center'>
              {!isLoading && (
                <ReactPaginate
                  breakLabel='...'
                  nextLabel={`${t("next")} >`}
                  onPageChange={handleNext}
                  pageRangeDisplayed={5}
                  pageCount={Math.ceil(pageCount)}
                  initialPage={page - 1}
                  previousLabel={`< ${t("previous")}`}
                  renderOnZeroPageCount={null}
                  containerClassName='pagination'
                  previousLinkClassName='pagination__link'
                  nextLinkClassName='pagination__link'
                  disabledClassName='pagination__link--disabled'
                  activeLinkClassName='pagination__link--active'
                />
              )}
            </div>
            <div className='flex items-center'>
              <div className='my-2 h-[36px] relative '>
                <input
                  autoFocus
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className='p-1 h-full border pr-[32px] outline-none rounded w-[250px]'
                  placeholder={t("search")}
                />
                <AiOutlineSearch
                  size={24}
                  color={Colors.mainAqwaBlue}
                  className='absolute -translate-y-1/2 top-1/2 right-1'
                />
              </div>
            </div>
          </div>
          {/* Table Body */}
          <div className='flex flex-col w-full h-full overflow-auto'>
            {isLoading ? (
              <Loading />
            ) : (
              <>
                <Table
                  unSelectedColumns={unSelectedColumns}
                  history={history}
                  sort={sort}
                  setSort={(lb) => setSort(lb)}
                  hrefId={hrefId}
                  returnAllData={returnAllData}
                  onClickItem={(a) => onClickItem(a)}
                  isLoading={isLoading}
                  data={data}
                  columns={columns}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export const Table = ({
  columns,
  sort,
  unSelectedColumns,
  setSort,
  data,
  onClickItem,
  hrefId,
}) => {
  const onClickHeader = (item) => {
    if (!item.sort) return;
    const isSelected = sort.find((a) => a.query === item.query);
    if (isSelected) {
      if (isSelected.sortBy === 1) setSort([{ sort: item.sort, sortBy: -1 }]);
      else setSort([{ sort: item.sort, sortBy: 1 }]);
    } else {
      setSort([{ sort: item.sort, sortBy: 1 }]);
    }
  };

  columns = columns.filter((a) => !unSelectedColumns.includes(t(a.label)));

  return (
    <div className='flex flex-col w-full my-6 max-h-[600px] '>
      <div className='flex min-w-[600px] items-center justify-between px-1 py-4 rounded bg-slate-100 '>
        {columns.map((a, i) => (
          <div
            key={i}
            onClick={onClickHeader.bind(this, a)}
            className='w-1/4 flex cursor-pointer items-center text-[15px] opacity-90'>
            <p className='mx-2'>{t(a.label)}</p>
            {a.sort && <BiSortAlt2 color='#ccc' className='' size={22} />}
          </div>
        ))}
      </div>
      <div className='flex flex-col w-full h-full '>
        <div>
          {data.items.map((a, i) => (
            <div
              onClick={onClickItem.bind(this, hrefId ? a[hrefId] : a)}
              key={i}
              className={`flex ${
                i % 2 === 0 ? "bg-[#fff]" : "bg-[#f4f3f3]"
              } min-w-[600px] items-center justify-center h-[60px]  p-1 py-4 font-medium border-b rounded cursor-pointer `}>
              {columns.map(({ value, classnames }, j) => (
                <div
                  key={j}
                  className={`w-1/4 text-[14px] h-[55px] flex ${
                    classnames ? classnames(a) : ""
                  } items-center whitespace-pre-wrap overflow-hidden text-ellipsis opacity-90`}>
                  {value(a)}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Loading = () => {
  return (
    <div
      className='flex items-center justify-center flex-1 w-full'
      style={{ height: "auto" }}>
      <Lottie
        height={500}
        width={500}
        isClickToPauseDisabled={false}
        options={{
          animationData: animationLoading,
          loop: true,
          autoplay: true,
        }}
      />
    </div>
  );
};
export const Error = () => {
  return (
    <div
      className='flex items-center justify-center flex-1 w-full'
      style={{ height: "auto" }}>
      <Lottie
        height={600}
        width={600}
        isClickToPauseDisabled={false}
        options={{ animationData, loop: true, autoplay: true }}
      />
    </div>
  );
};

const ExportModal = ({
  exportModal,
  centerId,
  url,
  columns,
  onClickExportExcel,
}) => {
  const [unSelectedColumns, setUnSelectedColumns] = useState([]);

  const handleCheckboxChange = (item) => {
    const isSelected = unSelectedColumns.includes(item);

    if (isSelected) {
      setUnSelectedColumns(
        unSelectedColumns.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      setUnSelectedColumns([...unSelectedColumns, item]);
    }
  };

  const onExport = async () => {
    try {
      const res = await axios.get(url("&centerId=" + centerId));
      console.log(res.data);
      console.log(columns);
      //export to excel
      const data = res.data.map((a, i) => {
        const obj = {};
        columns
          .filter((a) => !unSelectedColumns.includes(a.label))
          .forEach((b) => {
            obj[t(b.label)] = b.value(a);
          });
        return obj;
      });
      console.log(data);
    } catch (e) {
      console.log(e);
      alert("error");
    }
  };
  return (
    <div
      className={`absolute flex items-center  ${
        exportModal ? "opacity-100 z-[1000]" : "opacity-0 z-0"
      } duration-300 transition-all justify-center bg-black/50 w-full h-full  -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2`}>
      <div className='flex flex-col p-2 w-[50%] h-auto bg-white rounded-lg'>
        <div className='flex items-center justify-between'>
          <span className='text-lg font-bold'>{t("exportViaExcel")}</span>
          <IoCloseOutline
            className='cursor-pointer '
            onClick={onClickExportExcel}
            size={30}
          />
        </div>

        <div className='my-6'>
          <span className='font-normal'>{t("selectColumns")}</span>
          <div className='flex flex-wrap'>
            {columns.map((a, i) => (
              <div
                key={i}
                onClick={handleCheckboxChange.bind(this, a.label)}
                className={`flex items-center justify-center p-2 m-2 text-sm border rounded-lg cursor-pointer ${
                  unSelectedColumns.includes(a.label)
                    ? "border-gray-500 "
                    : "border-green-600"
                } text-black border-[2px]`}>
                {t(a.label)}
              </div>
            ))}
          </div>
        </div>
        <div className='flex items-center justify-center w-full'>
          <div
            onClick={onExport}
            className='p-2 mb-2 text-xl text-white bg-green-600 border border-none cursor-pointer'>
            {t("exportViaExcel")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowPaginationData;
